import React from 'react'
import styles, { layout } from '../../style'
import { aws, screen, python } from '../../assets'


const Screen = () => {
  return (
    <section id="product" className={layout.sectionReverse}>
      <div
        className={layout.sectionImgReverse}>
          <img src={screen} alt="billing" className='w-[100%] h-[100%] relative z-[5]' />
      </div>
      <div className='absolute z-[3] -left-1/2 top-0 w-[50%] rounded-full white__gradient' />
      <div className='absolute z-[3] -left-1/2 bottom-0 w-[50%] rounded-full pink__gradient' />

      <div className={layout.sectionInfo}>
        <h2 className={styles.heading2}>Explore the power of our platform <br className='sm:block hidden'/> 
          and data ecosystem.
        </h2>
        <p className={`${styles.paragraph} max-w-[470px] mt-5`}>
          Targeting the right customers and converting visitors into buyers 
          is one of the top challenges for real estate firms. We provide an 
          active, always-on resolution network to strengthen customer 
          segmentation, enhanced list building, and personalized customer 
          buyer journeys, giving you visibility on who to target and how to 
          tailor messaging to improve conversion.
        </p>
        <div className='flex flex-row flex-wrap sm:mt-10 mt-6'>
          <img src={aws} alt="aws_powered"
            className='w-[128px] h-[42px] object-contain mr-5 cursor-pointer' />
          <img src={python} alt="python_powered"
            className='w-[128px] h-[42px] object-contain mr-5 cursor-pointer' />
        </div>
      </div>
    </section>
  )
}

export default Screen